import { ColorThemeType } from '@qlevr/shared/constants';
import { LinkImageCardInterface } from '@qlevr/shared/interfaces';
import isEmpty from 'lodash.isempty';
import ThemeCard from '../theme/theme';
import clsx from 'clsx';
import ImageRenderer from '../image-renderer/image-renderer';
import LinkRenderer from '../link/link-renderer';

export interface MenuProductsStackedProps {
  products: LinkImageCardInterface[] | null;
  hasFeaturedCard?: boolean;
  theme: ColorThemeType;
}

export function MenuProductsStacked(props: MenuProductsStackedProps) {
  if (!props.products || isEmpty(props.products)) {
    return null;
  }

  return (
    <div className="px-5">
      <div className="flex flex-col gap-2">
        {props.products.map((product, key) => (
          <ThemeCard className={clsx('relative rounded-lg px-4 py-3 shadow')} theme={props.theme} key={key}>
            <div className="flex h-full items-center gap-4">
              <div className="max-w-24">
                <ImageRenderer loadingState="lazy" image={product.image} className="lg:aspect-5/4" />
              </div>
              <div className="text-center capitalize">
                <LinkRenderer
                  cta={{
                    ...product.cta,
                    wrapperClassName: 'after:inset-0 after:absolute leading-none',
                    className: '!text-base font-semibold',
                  }}
                />
              </div>
            </div>
          </ThemeCard>
        ))}
      </div>
    </div>
  );
}

export default MenuProductsStacked;
